import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const dropdownV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Dropdown element to v2 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'dropdown'>): void => {
    const dropdownProps = props;

    if (dropdownProps?.style?.general?.title && !dropdownProps?.content?.title?.iconColor) {
      const currentColor = dropdownProps.style.general.title.color1;
      dropdownProps.content = {
        ...dropdownProps.content,
        title: {
          ...dropdownProps.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
